<template>
  <div>
    <div style="margin:1%">
      <b-col style="margin:5px">
        <md-button @click.stop="showFormGroups" class="md-raised">{{ $t('Add') }}</md-button>
      </b-col>
      <b-table small striped hover :items="groupsUser" :fields="fieldsGroups">
        <template v-slot:cell(actions)="row">
        <i @click.stop="deleteGroups(row)" class="danger fa fa-trash-alt fa-lg" />
        </template>
      </b-table>
    </div>

      <b-modal ref="addGroupsUser" hide-footer :title="$t('Groups')">
        <FormAddGroup @hideFormGroups="hideFormGroups" :userInfo="userInfo" :currentRow="currentRow"></FormAddGroup>
      </b-modal>
  </div>
</template>

<script>
import FormAddGroup from './formAddGroup'
export default {
  components: {
    FormAddGroup
  },
  props: {
    currentRow: null,
    userInfo: null
  },
  data () {
    return {
      fieldsGroups: [
        { key: 'group_id', label: 'ID', sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      selectGroup: null
    }
  },
  methods: {
    deleteGroups (row) {
      this.selectGroup = row.item
      this.userInfo.groups = this.userInfo.groups.filter((value) => {
        return value !== this.selectGroup.group_id
      })
    },
    showFormGroups () {
      this.$refs.addGroupsUser.show()
    },
    hideFormGroups () {
      this.$refs.addGroupsUser.hide()
    }
  },
  computed: {
    groupsUser () {
      let copy = JSON.parse(JSON.stringify(this.userInfo.groups))
      let tmp = []
      for (let el of copy) {
        for (let elGroup of this.$store.getters['Users/GROUPS']) {
          if (el === elGroup.group_id) {
            tmp.push(elGroup)
          }
        }
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/groups/main.vue